// We can't use the theme in this stylesheet due to some SSG pre-render race condition
import { grey } from '@mui/material/colors';

const faqStyle = () => ({
  homeCta: {
    alignSelf: 'flex-end',
    margin: 'auto',
    textAlign: 'center',

    '.blogTitle': {
      // display: '-webkit-box',
      // overflow: 'hidden',
      // WebkitBoxOrient: 'vertical',
      // WebkitLineClamp: 3,
      lineHeight: '2.5rem'
    }
  },

  faqNav: {
    alignContent: 'start',
    alignItems: 'flex-start',
    gap: 15,
    marginBottom: 40
  },

  faqAccordion: {
    paddingRight: 10,
    paddingLeft: 10,
    h4: {
      fontSize: '1.2rem',
      fontWeight: 500
    },

    '.imageCaption': {
      textAlign: 'center',
      fontSize: '0.9rem',
      color: grey[600]
    }
  },
  faqSectionHeader: {
    marginTop: 0
  },
  accordionSummary: {
    color: '#333 !important',

    '&.Mui-expanded': {

    }
  }
});

export default faqStyle;
